import React, { Component } from 'react';
import './NewsWidget.css'
import i18n from 'i18next';
import { regionList } from './../lib/constants'
import { cc2ccy, ccy2cc } from './../lib/utils'
import { ReactComponent as PrevIcon } from './../img/prev.svg';
import { ReactComponent as NextIcon } from "./../img/next.svg";
import { ReactComponent as CloseIcon } from './../img/close.svg';
import axios from 'axios';
import Navbar from '../Components/Navbar';

export default class NewsWidget extends Component<any, any> {
    noOfPage: number
    headerPerPage: number
    noOfHeaders: number
    constructor(props: any) {
        super(props)
        this.noOfPage = 5;
        this.headerPerPage = 20;
        this.noOfHeaders = this.noOfPage * this.headerPerPage

        this.state = ({
            fontSize: this.props.fontSize,
            token: this.props.token,
            lang: this.props.lang,
            region: (this.props.cc === 'BN' || this.props.cc === 'HK' ? '' : this.props.cc) || "",
            newslang: 'ALL',
            newsStoryID: '',
            headerIndex: -1, // start from 0
            currentPage: 1,
            noOfNews: 0,
            isModalOpen: false,
            ischecked: false,
            data: [],
            Nextdata: [],
            newsDetail: [],
        })
    }

    componentDidMount = () => {
        // scrolltotop from fxwidget's related news' more news or direct news
        if (this.props.history.location.state && this.props.history.location.state.scrollToTop){
            window.scrollTo(0,0)
        }
        // passing fxwidget's cc to news and open modal from fxwidget
        if (this.props.history.location.state && this.props.history.location.state.isModalOpen) {
            this.setState({
                isModalOpen: true,
                newsStoryID: this.props.history.location.state.newsStoryID,
                region: this.props.history.location.state.cc
            })
            this.NewsHeaderAPI(this.props.history.location.state.cc, this.state.newslang, this.state.currentPage)
            this.NewsStoryAPI(this.props.history.location.state.newsStoryID);
        // passing fxwidget's cc to news
        } else if(this.props.history.location.state && this.props.history.location.state.cc){
            this.setState({
                // newsStoryID: this.props.history.location.state.newsStoryID,
                region: this.props.history.location.state.cc
            })
            this.NewsHeaderAPI(this.props.history.location.state.cc, this.state.newslang, this.state.currentPage)
            // this.NewsStoryAPI(this.props.history.location.state.newsStoryID);
        // normal render from opening the page in navbar
        } else {
            this.NewsHeaderAPI(this.state.region, this.state.newslang, this.state.currentPage)
            if(this.state.newsStoryID !== ''){
                this.NewsStoryAPI(this.state.newsStoryID);
            }
        }
        this.props.history.push('/news?lang=' + this.props.lang + '&cc=' + this.props.cc);
        this.props.widget(false)
    }

    componentWillReceiveProps(nextProps: any) {
        if(this.state.isModalOpen){
            this.setState({
                isModalOpen: false
            })
        }
        if (nextProps.lang !== this.props.lang) {
            this.props.history.push('/news?lang=' + nextProps.lang + '&cc=' + nextProps.cc);
        }
    }

    // provide page number and number per page to get news header
    NewsHeaderAPI = (region: string, newslang: string, currentPage: number) => {
        let base_url = this.props.domain + "/bochkfxwidget/data/news?";
        let newstype = "IDN";
        let underscore = new Date().getTime()
        let cc = region;
        let url = base_url + "newstype=" + newstype + "&newslang=" + newslang + "&lang=" + this.state.lang
            + "&rpp=" + this.noOfHeaders + "&cc=" + cc + "&pn=" + Math.ceil(this.getFristPage(currentPage) / this.noOfPage)
            + "&_=" + underscore + "&token=" + this.state.token;
        axios.get(url)
            .then(res => {
                this.setState({
                    data: { status: "loaded", payload: res.data },
                    noOfNews: res.data.data.news.length,
                    currentPage: currentPage,
                    // headerIndex: headerIndex

                });
            })
        //getting next 20
        url = base_url + "newstype=" + newstype + "&newslang=" + newslang + "&lang=" + this.state.lang
            + "&rpp=" + this.headerPerPage + "&cc=" + cc + "&pn=" + (this.getFristPage(currentPage) + this.noOfPage)
            + "&_=" + underscore + "&token=" + this.state.token;
        axios.get(url)
            .then(res => {
                this.setState({ Nextdata: { status: "loaded", payload: res.data } });
            })
    }
    // provide story id to get story detail
    NewsStoryAPI = (newsStoryID: string) => {
        let base_url = this.props.domain + "/bochkfxwidget/data/newsstory?";
        let underscore = new Date().getTime()
        let url = base_url + "id=" + newsStoryID + "&newslang=" + this.state.newslang + "&lang=" + this.state.lang
            + "&_=" + underscore + "&token=" + this.state.token;
        if (url && newsStoryID !== "") {
            axios.get(url)
                .then(res => this.setState({ newsDetail: { status: "loaded", payload: res.data } }))
                .catch(error => this.setState({ newsDetail: { status: "error", error } }))
        } else {
            this.setState({ newsDetail: { status: "init" } })
        }
    }
    // perform only when the modal is opened and next or prev news will lead to load new header
    NewsStoryWithnewHeaderAPI = (region: string, newslang: string, currentPage: number, headerIndex: number) => {
        let base_url = this.props.domain + "/bochkfxwidget/data/news?";
        let newstype = "IDN";
        let underscore = new Date().getTime()
        let cc = region;
        let url = base_url + "newstype=" + newstype + "&newslang=" + newslang + "&lang=" + this.state.lang
            + "&rpp=" + this.noOfHeaders + "&cc=" + cc + "&pn=" + Math.ceil(this.getFristPage(currentPage) / this.noOfPage)
            + "&_=" + underscore + "&token=" + this.state.token;
        axios.get(url)
            .then(res => {
                this.setState({
                    data: { status: "loaded", payload: res.data },
                    noOfNews: res.data.data.news.length,
                    currentPage: currentPage,
                    headerIndex: headerIndex
                })
                var newStoryID = res.data.data.news[headerIndex].id
                this.NewsStoryAPI(newStoryID);
            })
    }
    // change option in select
    changeSelect = (event: React.FormEvent<HTMLSelectElement>) => {
        var current_cc = ccy2cc(event.currentTarget.value)
        this.setState({
            region: current_cc,
        })
        this.NewsHeaderAPI(current_cc, this.state.newslang, 1)
    }
    // change news lang
    changenewslang = (lang: string) => {
        this.setState({
            newslang: lang
        })
        this.NewsHeaderAPI(this.state.region, lang, 1);
    }
    // Switch news within n page provided
    SwitchNews = (index: number) => {
        var maxheaders = this.noOfPage * this.headerPerPage - 1;
        if (index === 1) { // next
            if (this.state.headerIndex + 1 > maxheaders) {
                this.getnewNewsHeaders(1)
            } else {
                if ((this.state.headerIndex + 1) % this.headerPerPage === 0) {
                    this.setState({
                        currentPage: this.state.currentPage + 1
                    })
                }
                this.setState({
                    headerIndex: this.state.headerIndex + 1
                })
                this.NewsStoryAPI(this.state.data.payload.data.news[this.state.headerIndex + 1].id)
            }
        } else { // prev
            if (this.state.headerIndex - 1 < 0) {
                this.getnewNewsHeaders(-1)
            } else {
                if (this.state.headerIndex % this.headerPerPage === 0) {
                    this.setState({
                        currentPage: this.state.currentPage - 1
                    })
                }
                this.setState({
                    headerIndex: this.state.headerIndex - 1
                })
                this.NewsStoryAPI(this.state.data.payload.data.news[this.state.headerIndex - 1].id)
            }
        }
    }
    // Open Modal
    OpenModal = (newsId: string, headerIndex: number) => {
        this.setState({
            newsStoryID: newsId,
            headerIndex: headerIndex,
            isModalOpen: true
        })
        this.NewsStoryAPI(newsId)
    }
    // Close Modal
    CloseModal = () => {
        this.setState({
            isModalOpen: false,
            newsDetail: ''
        })
    }
    // if noOfPage = 5, 1-5 return 1, 6-10 return 6 ... if noOfPage = 10, 1-10 return 1, 11-20 return 11 ...
    getFristPage = (index: number) => {
        return Math.floor((index - 1) / this.noOfPage) * this.noOfPage + 1
    }
    // when click on page controller next / prev n page
    getnewNewsHeaders = (index: number) => {
        if (index === 1) { // index = 1 = next n page
            var currentPageStart = this.getFristPage(this.state.currentPage);
            var nextPageStart = currentPageStart + this.noOfPage;
            if (this.state.isModalOpen) {
                this.NewsStoryWithnewHeaderAPI(this.state.region, this.state.newslang, nextPageStart, 0)
            } else {
                this.NewsHeaderAPI(this.state.region, this.state.newslang, nextPageStart)
            }

        } else { // index = -1 -> prev n page
            currentPageStart = this.getFristPage(this.state.currentPage);
            var previousPageEnd = currentPageStart - 1;
            if (previousPageEnd > 0) {
                if (this.state.isModalOpen) {
                    this.NewsStoryWithnewHeaderAPI(this.state.region, this.state.newslang, previousPageEnd, (this.noOfPage * this.headerPerPage - 1))
                } else {
                    this.NewsHeaderAPI(this.state.region, this.state.newslang, previousPageEnd)
                }
            }
        }
    }
    // JSX of the Modal
    Modal = () => {
        var hasNextNews = false;
        if (this.state.data.status === 'loaded') {
            if (this.state.data.payload.data.news.length > this.state.headerIndex + 1) {
                hasNextNews = true
            } else {
                if (this.state.headerIndex + 1 === this.noOfHeaders && this.state.Nextdata.payload.data.news.length > 0) {
                    hasNextNews = true
                }
            }
        }
        return (
            <div className='Modal'>
                <div className='menu'>
                    <div className='control'>
                        {this.state.currentPage === 1 && this.state.headerIndex === 0
                            ? <div className='prev invalid'><PrevIcon /></div>
                            : <div className='prev' onClick={() => this.SwitchNews(-1)}><PrevIcon /> </div>
                        }
                        {hasNextNews
                            ? <div className='next' onClick={() => this.SwitchNews(1)}> <NextIcon />  </div>
                            : <div className='next invalid'> <NextIcon /> </div>
                        }
                    </div>
                    <div className='close' onClick={this.CloseModal}>
                        <CloseIcon />
                    </div>
                </div>
                {this.state.newsDetail && this.state.newsDetail.status === 'loaded' &&
                    <div className='body'>
                        <div className='headline'>
                            {this.state.newsDetail.payload.data.newsstory.hl}
                        </div>
                        <div className='time'>
                            {this.state.newsDetail.payload.data.newsstory.dt.substring(0, 4) + '/' + this.state.newsDetail.payload.data.newsstory.dt.substring(4, 6) + '/' + this.state.newsDetail.payload.data.newsstory.dt.substring(6, 8) + ' '}
                            {this.state.newsDetail.payload.data.newsstory.dt.substring(8, 10) + ':' + this.state.newsDetail.payload.data.newsstory.dt.substring(10, 12)}
                        </div>
                        <div className='passage' dangerouslySetInnerHTML={{ __html: this.state.newsDetail.payload.data.newsstory.body }} />
                    </div>
                }
            </div>
        )
    }
    // JSX of the page controller
    PageController = () => {
        const page_shown: number[] = [];
        let startingPage = this.getFristPage(this.state.currentPage);
        if (this.state.data && this.state.data.status === 'loaded') {
            var numOfPageDisplay = Math.ceil(this.state.noOfNews / this.headerPerPage)
            for (let i = 0; i < this.noOfPage; i++) {
                if (i < numOfPageDisplay) {
                    page_shown.push(startingPage + i)
                } else {
                    page_shown.push(-1)
                }
            }
        }
        let prev = '<'
        let next = '>'
        const currentPage = this.state.currentPage

        return (
            <div className='Page-Control-Container'>
                <div />
                <div className='Page-Control'>
                    <div className={'arrow' + (this.getFristPage(this.state.currentPage) === 1 ? " invalid" : "")} onClick={() => this.getnewNewsHeaders(-1)}> {prev} </div>
                    {page_shown.map((item, i) => {
                        if (item >= 0) {
                            return (
                                <div key={i} className={'Page-Number' + (currentPage === item ? ' selected' : '')} onClick={() => this.setState({ currentPage: item })}>
                                    {item}
                                </div>
                            )
                        } else {
                            return (<div key={i} className='Page-Number empty' />)
                        }
                    })}
                    {this.state.Nextdata.status === 'loaded' && this.state.Nextdata.payload.data.news.length > 0
                        ? <div className='arrow' onClick={() => this.getnewNewsHeaders(+1)} > {next} </div>
                        : <div className="arrow invalid" > {next} </div>
                    }

                </div>
            </div>
        )
    }
    // JSX of select list
    RegionList = () => {
        const list = [];
        for (let i = 0; i < regionList.length; i++) {
            list[i] = regionList[i].cd
        }
        return (
            <select onChange={e => this.changeSelect(e)} value={cc2ccy(this.state.region)}>
                {list.map(function (item, i) {
                    return (
                        <option key={i} value={item}>
                            {i18n.t("Common." + item)}
                        </option>
                    )
                })}
            </select>
        )
    }

    render() {
        return (
            <div>
                <Navbar lang={this.state.lang} cc={this.props.cc} />
                <div className='content' style={{ fontSize: this.props.fontSize }}>
                    <div className='title' onClick={()=>this.CloseModal()}>{i18n.t("News.Title")}{ i18n.t("Common." + cc2ccy(this.state.region)) }</div>
                    <div className={'container' + (this.state.isModalOpen ? ' hide' : '')}>
                        <div className="select_bar">
                            <div className='select_container'>
                                {i18n.t("Common.Currency")}
                                <this.RegionList />
                            </div>

                            <div className="select_lang">
                                <div className={"lang" + (this.state.newslang === 'ALL' ? ' selected' : '')} onClick={() => this.changenewslang("ALL")}>{i18n.t("Common.ALL")}</div>
                                <div className={"lang" + (this.state.newslang === 'CHI' ? ' selected' : '')} onClick={() => this.changenewslang("CHI")}>中文</div>
                                <div className={"lang" + (this.state.newslang === 'ENG' ? ' selected' : '')} onClick={() => this.changenewslang("ENG")}>ENG</div>
                            </div>
                        </div>
                        <div className="News-Table">
                            <div className="News-Table-Header">
                                <div className="News-Table-Col1">{i18n.t("News.DateAndTime")}</div>
                                <div className="News-Table-Col2">{i18n.t("News.Heading")}</div>
                            </div>
                            {this.state.data && this.state.data.status === 'loaded' &&
                                this.state.data.payload.data.news.map((item: any, i: number) => {
                                    if (i >= ((this.state.currentPage - 1) % this.noOfPage) * this.headerPerPage && i < ((this.state.currentPage - 1) % this.noOfPage + 1) * this.headerPerPage) {
                                        return (
                                            <div className="News-Table-Data" key={i}>
                                                <div className="News-Table-Col1">{item.dt.substring(4, 6) + "/" + item.dt.substring(6, 8) + " " + item.dt.substring(8, 10) + ":" + item.dt.substring(10, 12)}</div>
                                                <div className="News-Table-Col2" onClick={() => this.OpenModal(item.id, i)}>{item.hl}</div>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                        <this.PageController />
                        <br /><br />
                        <div>
                            {i18n.t("Common.Update")}
                            {this.state.data && this.state.data.status === "loaded"
                                ? ' ' + this.state.data.payload.ts.substring(0, 4) + '/' + this.state.data.payload.ts.substring(4, 6) + '/' + this.state.data.payload.ts.substring(6, 8) + ' ' +
                                this.state.data.payload.ts.substring(8, 10) + ':' + this.state.data.payload.ts.substring(10, 12)
                                : ''
                            }
                        </div>
                    </div>
                    {this.state.isModalOpen
                        ? <this.Modal />
                        : ''
                    }
                </div>
            </div>
        )
    }
}
